import styled from 'styled-components';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';

const CntWrap = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <>
      <Wrap>
        <TitleText>{title}</TitleText>
        {children}
      </Wrap>
    </>
  );
};

export default CntWrap;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
`;

const TitleText = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #111;
  margin-bottom: 20px;
`;
